import { apiClient } from '../Api';
import type { AuthSignInParams, AuthSignUpParams, LoginResult, SessionListener, SignUpResult } from './types';

export const authService = {
  getSession: () => apiClient.auth.getSession(),

  login: (params: AuthSignInParams): Promise<LoginResult> => apiClient.auth.signIn(params),

  signUp: (params: AuthSignUpParams): Promise<SignUpResult> => apiClient.auth.signUp(params),

  signOut: () => apiClient.auth.signOut(),

  onAuthStateChange: (callback: SessionListener) => apiClient.auth.onAuthStateChange(callback),
};
